var globalFunctions = require('./globalFunctions.js');

module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title">'+
                        'EVENTS'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>A -0.5</li> '+
                            '<li>A +0.5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>A -1.5</li> '+
                            '<li>A +1.5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>A -2.5</li> '+
                            '<li>A +2.5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>A -3.5</li>'+
                            '<li>A +3.5</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                         '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="A -0.5" data-betCode="804" class="bet-choose" data-odd="'+quotes.AwayUnder05+'">'+globalFunctions.checkQuotes(quotes.AwayUnder05)+'</li> '+
                                '<li data-betType="A +0.5" data-betCode="806" class="bet-choose" data-odd="'+quotes.AwayOver05+'">'+globalFunctions.checkQuotes(quotes.AwayOver05)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="A -1.5" data-betCode="814" class="bet-choose" data-odd="'+quotes.AwayUnder15+'">'+globalFunctions.checkQuotes(quotes.AwayUnder15)+'</li> '+
                                '<li data-betType="A +1.5" data-betCode="816" class="bet-choose" data-odd="'+quotes.AwayOver15+'">'+globalFunctions.checkQuotes(quotes.AwayOver15)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="A -2.5" data-betCode="824" class="bet-choose" data-odd="'+quotes.AwayUnder25+'">'+globalFunctions.checkQuotes(quotes.AwayUnder25)+'</li> '+
                                '<li data-betType="A +3.5" data-betCode="826" class="bet-choose" data-odd="'+quotes.AwayOver25+'">'+globalFunctions.checkQuotes(quotes.AwayOver25)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="A -3.5" data-betCode="834" class="bet-choose" data-odd="'+quotes.AwayUnder35+'">'+globalFunctions.checkQuotes(quotes.AwayUnder35)+'</li> '+
                                '<li data-betType="A +3.5" data-betCode="836" class="bet-choose" data-odd="'+quotes.AwayOver35+'">'+globalFunctions.checkQuotes(quotes.AwayOver35)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};




//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/away_under_over.js
// module id = 2015
// module chunks = 4